import { projectSettings } from "../../config";

const loqateFind = "https://hosted.mastersoftgroup.com/harmony/rest/v2/address/find";
const loqateRetrieve = "https://hosted.mastersoftgroup.com/harmony/rest/v2/address/retrieve";
const authorization = `Basic ${projectSettings.loqateCredentials}`;

let retryCount = 0;
let retryLimit = 2;

export const findAddress = async (countryCode, query) => {
    let suggestions = [];

    let sourceOfTruth = "GNAF";
    if (countryCode === "nz") {
        sourceOfTruth = "NZAD";
    } else if (query.toLowerCase().startsWith("po box") || query.toLowerCase().startsWith("locked bag")) {
        sourceOfTruth = "AUPAF";
    }

    try {
        let resp = await fetch(
            `${loqateFind}?country=${countryCode}&fullAddress=${encodeURIComponent(query)}&sourceOfTruth=${sourceOfTruth}`,
            {
                method: "GET",
                headers: {
                    Authorization: authorization
                }
            }
        );

        if (!resp.ok) {
            throw new Error(`HTTP error! status: ${resp.status}`);
        }

        let data = await resp.json();

        if (data.status !== "SUCCESS") {
            throw new Error(`Reqest error! status: ${data.status}`);
        }

        suggestions = data.payload || [];
    } catch (error) {
        console.error("Failed to fetch address suggestions:", error);
        suggestions = [];
    }

    return suggestions;
};

export const retrieveAddress = async (address, addressId) => {
    try {
        let resp = await fetch(`${loqateRetrieve}?id=${encodeURIComponent(addressId)}`, {
            method: "GET",
            headers: {
                Authorization: authorization
            }
        });

        if (!resp.ok) {
            throw new Error(`HTTP error! status: ${resp.status}`);
        }

        let data = await resp.json();

        if (data.status !== "SUCCESS" || !data.payload.length) {
            throw new Error(`Reqest error! status: ${data.status}`);
        }

        const addressResult = data.payload[0];
        
        // Populate the address object
        address = parseAddress(address, addressResult);

        retryCount = 0;

        return address;
    } catch (error) {
        console.error("Failed to fetch address suggestions:", error);
        if (retryCount++ >= retryLimit) {
            return null;
        } else {
            return retrieveAddress(address, addressId);
        }
    }
};

export const parseAddress = (address, addressResult) => {	
    address.ThirdPartyValidated = true;
    address.ThirdPartyValidationId = addressResult.id;
    address.ValidationVendor = "Loquate";

    address.FormattedAddress = addressResult.fullAddress;

    address.Lat = !!addressResult.attributes?.Latitude ? addressResult.attributes?.Latitude : null;
    address.Lng = !!addressResult.attributes?.Longitude ? addressResult.attributes?.Longitude : null;
   
    switch (address.CountryCode.toLowerCase()) {
        case "au":
        case "australia":
            address = {...address, ...parseAustralianAddress(addressResult)};
            break;
        default:
            address = {...address, ...parseInternationalAddress(addressResult)};
            break;
    }
    
    return address;
}

const parseAustralianAddress = (addressResult) => {   
    let address = {};

    address.Premise = !!addressResult.buildingName ? addressResult.buildingName : null;
    address.Subpremise = !!addressResult.subdwelling ? addressResult.subdwelling : null;
    address.Street = `${!!addressResult.streetNumber ? addressResult.streetNumber + " " : ""}${addressResult.street}`;
    address.Street2 = !!addressResult.street2 ? addressResult.street2 : null;
    address.Suburb = addressResult.attributes?.City;
    address.State = addressResult.attributes?.ProvinceCode;
    address.Postcode = addressResult.postcode;
    address.Country = addressResult.country;

    return address;
}

const parseInternationalAddress = (addressResult) => {   
    let address = {};

    address.Premise = !!addressResult.buildingName ? addressResult.buildingName : null;
    address.Subpremise = !!addressResult.subdwelling ? addressResult.subdwelling : null;
    address.Street = `${!!addressResult.streetNumber ? addressResult.streetNumber + " " : ""}${addressResult.street}`;
    address.Street2 = !!addressResult.street2 ? addressResult.street2 : null;
    address.Suburb = addressResult.attributes?.City;
    address.State = addressResult.attributes?.ProvinceName;
    address.Postcode = addressResult.postcode;
    address.Country = addressResult.country;

    return address;
}
